const list = document.querySelector(".event-list");
const eventFilters = document.querySelector(".event-list__filters") != null ? document.querySelector(".event-list__filters") : null;
const loadMore = document.querySelector(".event-list__more");
let unshowEvents = [];
let filteredList;
let activeFilter;
let isCalendar = false;



function eventsListMore() {
    if (list) {
        const events = [...list.children].filter(event => !event.classList.contains('event-list__card-sizer'));
        const elementsToShow = parseInt(list.dataset.show);

        if (events.length > elementsToShow) {
            events.slice(elementsToShow).forEach(event => {
                event.classList.add("d-none");
                unshowEvents.push(event)
            });
            loadMore.classList.remove("d-none")
        }

        loadMore.addEventListener("click", () => {
            unshowEvents.slice(0, elementsToShow).forEach(event => {
                event.classList.remove("d-none");
                unshowEvents.shift();
            });
            if (unshowEvents.length === 0) {
                loadMore.classList.add("d-none");
            }
            msnry.layout();
        });
    }
}

function showCalendar() {
    if (list) {
        const events = [...list.children].filter(event => !event.classList.contains('event-list__card-sizer'));
        const calendarBoxes = document.querySelectorAll(".event-list__calendar-options");

        if (events) {
            window.addEventListener("click", (e) => {
                if (isCalendar && !e.target.parentElement.className.includes("calendar")) {
                    calendarBoxes.forEach(box => {
                        box.classList.add("d-none");
                    })
                }
            });

            events.forEach(event => {
                const calendarButton = event.querySelector(".event-list__calendar");
                const calendarOptions = event.querySelector(".event-list__calendar-options");

                if (calendarButton) {
                    calendarButton.addEventListener("click", (e) => {
                        calendarBoxes.forEach(box => {
                            if (!box.classList.contains("d-none")) {
                                box.classList.add("d-none");
                            }
                        })
                        calendarOptions.classList.remove("d-none");
                        isCalendar = true;
                    })
                }
            });
        }
    }
}

function filterEvents() {
    if (eventFilters && list) {
        const events = [...list.children].filter(event => !event.classList.contains('event-list__card-sizer'));
        const filters = [...eventFilters.children]
        const elementsToShow = parseInt(list.dataset.show);
        filteredList = filters;

        eventFilters.addEventListener("click", (e) => {
            filteredList = [];
            unshowEvents = [];
            let eventsCount = 0;

            if (e.target.classList.contains("btn")) {
                const category = e.target.dataset.category
                activeFilter = category;
                filters.forEach(filter => {
                    filter.firstElementChild.classList.remove("active");
                });

                e.target.classList.add("active");

                events.forEach((event, idx) => {
                    if (event.dataset.category == category || category == "all") {
                        filteredList.push(event);

                        if (eventsCount < elementsToShow) {
                            event.classList.remove("d-none");
                        } else {
                            event.classList.add("d-none");
                            unshowEvents.push(event)
                        }
                        eventsCount++

                    } else {
                        event.classList.add("d-none")
                    }

                    if (events.length === idx + 1) {
                        msnry.layout();
                    }
                });

                if (eventsCount > elementsToShow) {
                    loadMore.classList.remove("d-none");
                } else {
                    loadMore.classList.add("d-none");
                }
            }
        })
    }
}

var masonryPackagePath = "/scripts/vendor/masonry.pkgd.min.js";
$.getScript(masonryPackagePath, function () {
    $('#masonry-container').masonry({
        itemSelector: '.event-list__card',
        columnWidth: '.event-list__card-sizer',
        gutter: 10,
        horizontalOrder: true,
        fitWidth: true
    });
});

$(document).ready(function () {
    eventsListMore();
    showCalendar();
    filterEvents();
});
